import React, { createContext, useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";

import { onDisconnect, get, onValue } from "firebase/database";

import { IFilaAtendimento } from "../../Interfaces/Cobranca/FilaAtendimento/FilaAtendimentoInterface";
import {
    DeslogarUsuarioHelpDeskController,
    LogarUsuarioHelpDeskController,
} from "../../Controllers/HelpDesk/User/UserHelpDeskControllers";
import { useUserInfor } from "../User";
import { GetEquipeUsuarioController } from "../../Controllers/HelpDesk/Equipes/EquipesControllers";
import { IEquipe } from "../../Interfaces/HelpDesk/Equipes/EquipeInterface";
import { IChat } from "../../Interfaces/HelpDesk/Equipes/Atendimento/AtendimentoInterfaces";
import { getChatsRef, goOnlineRef } from "../../Services/Config/ConfigFirebase";
import {
    GetAcaoFilaController,
    GetProximoAtendimentoController,
    ListarCasoCobrancaFilaAtendimentoDetalhadoPorGrupoController,
} from "../../Controllers/Cobranca/FilaAtendimento/FilaAtendimentoController";
import { AlertSuccess, AlertWarning } from "../../Tools/SweetAlerts";
import { IComponentModal } from "../../Components/Modais/IModalComponent";
import ModalComponent from "../../Components/Modais";
import ModoAtendimentoModal from "../../Components/Menu/QuickUsers/ModoAtendimentoModal";
import { faHeadset } from "@fortawesome/free-solid-svg-icons";
import { ACESSOS } from "../../Routes/Acessos";

interface IAtendimentoProviderProps {
    children: JSX.Element | JSX.Element[];
}
interface IIndicadoresFila {
    NR_ATENDIMENTOS: number;
    VL_ATENDIMENTOS: number;
}
interface IAtendimentoContext {
    fila?: IFilaAtendimento;
    modoAtendimento: "FILA" | "HELP DESK" | false;
    FL_MODO_ATENDIMENTO: boolean;
    FL_MODO_ATENDIMENTO_BLOQUEIO: boolean;
    FL_Ura_Telefonia: boolean;
    iniciarAtendimentoEmFila: (fila: IFilaAtendimento) => Promise<void>;
    goToNextAtendimento: () => Promise<void>;
    finalizarAtendimentoEmFila: () => void;
    selecionarFila: () => void;
    indicadoresFila: IIndicadoresFila | undefined;
    HELP_DESK: {
        FL_MODO_HELP_DESK: boolean;
        iniciarAtendimentoHelpDesk: () => void;
        finalizarAtendimentoHelpDesk: () => void;
        chatAberto?: IChat;
        setChatAberto: (chat?: IChat) => void;
        equipe: IEquipe;
        updateChatAberto: () => void;
    };
}

const AtendimentoContext = createContext<IAtendimentoContext>(
    {} as IAtendimentoContext
);

export function AtendimentoProvider(props: IAtendimentoProviderProps) {
    const history = useHistory();
    const { ID_ORGANIZACAO } = useUserInfor().OrgInfor;
    const { ID_USUARIO } = useUserInfor().UserInfor;
    const { OrgInfor } = useUserInfor();

    const [modoAtendimento, setModoAtendimento] = useState<
        "FILA" | "HELP DESK" | false
    >(false);
    const [fila, setFila] = useState<IFilaAtendimento>();
    const [indicadoresFila, setIndicadoresFila] = useState<IIndicadoresFila>();
    const [chatAberto, setChatAberto] = useState<IChat>();
    const [equipe, setEquipe] = useState<IEquipe>({} as IEquipe);

    const [modal, setModal] = useState<IComponentModal>();
    const [show, setShow] = useState(false);
    const [FL_Ura_Telefonia, setFL_Ura_Telefonia] = useState(false);

    useEffect(() => {
        if (ID_USUARIO) {
            GetEquipeUsuarioController().then((res) => {
                setEquipe(res);
            });
        }
    }, [ID_USUARIO]);

    const FL_MODO_ATENDIMENTO = modoAtendimento === "FILA";
    const FL_MODO_HELP_DESK = modoAtendimento === "HELP DESK";
    const FL_MODO_ATENDIMENTO_BLOQUEIO =
        FL_MODO_ATENDIMENTO || FL_MODO_HELP_DESK;

    const HELP_DESK = {
        FL_MODO_HELP_DESK,
        iniciarAtendimentoHelpDesk,
        finalizarAtendimentoHelpDesk,
        chatAberto,
        setChatAberto,
        equipe,
        updateChatAberto,
    };

    async function iniciarAtendimentoEmFila(fila: IFilaAtendimento) {
        setFila(fila);
        window.localStorage.setItem(
            "ULTIMA_FILA_MA",
            JSON.stringify({
                ID_GRUPO: fila.ID_GRUPO,
                ID_CAMPANHA: fila.ID_CAMPANHA,
            })
        );
        await goToNextAtendimentoPrivate(fila.ID_GRUPO, fila.ID_CAMPANHA);
    }
    async function goToNextAtendimentoPrivate(
        idGrupo: number,
        idCampanha: number
    ) {
        ListarCasoCobrancaFilaAtendimentoDetalhadoPorGrupoController(
            idGrupo,
            idCampanha
        ).then((res) => {
            setIndicadoresFila({
                NR_ATENDIMENTOS: res.LstFilaAtender.length,
                VL_ATENDIMENTOS: res.VL_FILAATENDER,
            });
        });

        GetAcaoFilaController(idGrupo).then((res) => {
            setFL_Ura_Telefonia(res.FL_DISCADOR ?? false);
        });

        await GetProximoAtendimentoController(idGrupo, idCampanha).then(
            (ID_ATENDIMENTO) => {
                if (ID_ATENDIMENTO) {
                    setModoAtendimento("FILA");
                    history.push(
                        ACESSOS.COBRANCA.TELAS.ATENDIMENTO.DS_LINK(
                            ID_ATENDIMENTO
                        )
                    );
                } else {
                    setModoAtendimento(false);
                    AlertSuccess(
                        "Não há mais nenhum atendimento nessa fila!!"
                    ).then(() => {
                        history.push("/Cobranca");
                        selecionarFila();
                    });
                }
            }
        );
    }
    async function goToNextAtendimento() {
        if (fila?.ID_GRUPO && fila.ID_CAMPANHA !== undefined)
            await goToNextAtendimentoPrivate(fila.ID_GRUPO, fila.ID_CAMPANHA);
    }
    function selecionarFila() {
        setShow(true);
        setModal({
            Component: () => <ModoAtendimentoModal setShow={setShow} />,
            headerComponent: "Ativar Fila de Atendimento",
            IconHeader: faHeadset,
            noFooter: true,
        });
    }
    function finalizarAtendimentoEmFila() {
        setModoAtendimento(false);
        setFila(undefined);
    }

    function iniciarAtendimentoHelpDesk() {
        LogarUsuarioHelpDeskController()
            .then(async (res) => {
                const equipeAtualizada =
                    await GetEquipeUsuarioController().then(
                        (equipeRes) => equipeRes
                    );
                if (
                    equipeAtualizada.ID_EQUIPE_HELP_DESK !==
                    equipe?.ID_EQUIPE_HELP_DESK
                )
                    setEquipe(equipeAtualizada);
                setModoAtendimento("HELP DESK");
                try {
                    if (ID_USUARIO) {
                        const onlineRef = goOnlineRef(
                            ID_ORGANIZACAO,
                            equipeAtualizada.ID_EQUIPE_HELP_DESK,
                            ID_USUARIO
                        );
                        onDisconnect(onlineRef).remove();
                        onValue(onlineRef, (snap) => {
                            if (!snap.exists()) {
                                AlertWarning("Você está offline");
                            }
                        });
                    }
                } catch (error) {
                    console.error(error);
                }
            })
            .catch((err) => {
                if (err?.status === 404) setEquipe({} as IEquipe);
            });
    }
    function finalizarAtendimentoHelpDesk() {
        DeslogarUsuarioHelpDeskController().then(() => {
            setModoAtendimento(false);
        });
    }

    function updateChatAberto() {
        if (chatAberto) {
            const ref = getChatsRef(
                OrgInfor.ID_ORGANIZACAO,
                chatAberto.NumeroAtendente,
                chatAberto.NumeroCliente
            );
            get(ref).then((snap) => {
                if (snap.exists()) {
                    setChatAberto(snap.val());
                }
            });
        }
    }

    return (
        <AtendimentoContext.Provider
            value={{
                modoAtendimento,
                FL_MODO_ATENDIMENTO,
                FL_MODO_ATENDIMENTO_BLOQUEIO,
                fila,
                indicadoresFila,
                finalizarAtendimentoEmFila,
                iniciarAtendimentoEmFila,
                selecionarFila,
                goToNextAtendimento,
                HELP_DESK,
                FL_Ura_Telefonia,
            }}
        >
            {props.children}
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </AtendimentoContext.Provider>
    );
}

export function useAtedimento() {
    const context = useContext(AtendimentoContext);
    if (!context)
        throw new Error(
            "useAtendimento necessita de um AtendimentoProvider em volta do que sera utilizado"
        );

    return context;
}
